import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const mapState = (state) => ({
  profile: state.userData.profile,
  packageTypes: state.paymentsData.packageTypes,
  locale: state.appData.locale,
});

// all account types
// 0 Free
// 1,6 professional(base)
// 2,7 comerical
// 3 experimental
// 8 premium
// 9 expired
// 10 premium plus

const getRequiredPlans = (array = [], PLANS, locale) => {
  const plans = [];
  const joinWord = locale === 'en' ? ' or ' : ' یا ';

  array.forEach((item) => {
    PLANS.forEach((p) => {
      if (p.index.includes(item) && !plans.includes(p.name)) {
        plans.push(p.name);
      }
    });
  });

  return plans.join(joinWord);
};

function AccessOverlay({ allowedTypes, setHasPageFunctionality }) {
  const { profile, packageTypes, locale } = useSelector(mapState);

  const showFreePackageOverlay = profile?.accountType === 0;
  const showPackageUpgradeOverlay =
    !!profile?.accountType && !allowedTypes.includes(profile?.accountType);

  const PLANS = [
    {
      index: [1, 6],
      name: packageTypes[6]?.[locale],
    },
    {
      index: [2, 7],
      name: packageTypes[7]?.[locale],
    },
    {
      index: [8],
      name: packageTypes[8]?.[locale],
    },
    {
      index: [10],
      name: packageTypes[10]?.[locale],
    },
  ];

  const getFreePackageOverlayText = (locale) => {
    if (locale === 'en') {
      return (
        <>
          This feature is not available in free package. to use this feature{' '}
          <a href='/dashboard/payment/package-upgrading'>upgrade</a> your
          package
        </>
      );
    }

    return (
      <>
        این قسمت در پکیج رایگان در دسترس نمیباشد.برای استفاده پکیج خود را{' '}
        <a href='/dashboard/payment/package-upgrading'> ارتقا </a> دهید.
      </>
    );
  };

  const getUpgradeToPackageOverlay = (locale) => {
    if (locale === 'en') {
      return (
        <>
          To use this feature{' '}
          <a href='/dashboard/payment/package-upgrading'> Upgrade </a> your
          packge to {getRequiredPlans(allowedTypes, PLANS, locale)}
        </>
      );
    }

    return (
      <>
        برای استفاده از این ویژگی پکیج خود را به{' '}
        {getRequiredPlans(allowedTypes, PLANS, locale)}{' '}
        <a href='/dashboard/payment/package-upgrading'> ارتقا </a> دهید.{' '}
      </>
    );
  };

  const renderFreePackageOverlay = (
    <div className='package_overlay'>
      <div className='content'>{getFreePackageOverlayText(locale)}</div>
    </div>
  );

  const renderUpgradePackage = (
    <div className='package_overlay'>
      <div className='content'>{getUpgradeToPackageOverlay(locale)}</div>
    </div>
  );

  useEffect(() => {
    if (
      setHasPageFunctionality &&
      (showFreePackageOverlay || showPackageUpgradeOverlay)
    )
      setHasPageFunctionality(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFreePackageOverlay, showPackageUpgradeOverlay]);

  //   Free Package overlay
  if (showFreePackageOverlay) return renderFreePackageOverlay;

  if (showPackageUpgradeOverlay) return renderUpgradePackage;

  return null;
}

AccessOverlay.defaultProps = {
  allowedTypes: [],
};

export default AccessOverlay;
